import styles from './Page.module.css'

var Error = () => <div className={styles.page}> 404 Not found </div>
export default Error